import { Mail, Phone, Linkedin } from "lucide-react";

function Contact() {
  return (
    <section
      id="contact"
      className="py-24 px-4 bg-gradient-to-br from-black via-gray-900 to-black text-white relative overflow-hidden"
    >
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute w-96 h-96 bg-green-500 rounded-full blur-3xl opacity-10 -top-48 -left-48"></div>
        <div className="absolute w-96 h-96 bg-emerald-500 rounded-full blur-3xl opacity-10 -bottom-48 -right-48"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-6xl md:text-7xl font-black mb-6 bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
            Let's Connect
          </h2>
          <p className="text-xl text-gray-400">
            Let's create positive change together and build a brighter future
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="animate-fade-in-delay-1">
            <div className="space-y-4">
              <input
                type="text"
                placeholder="Your Full Name"
                className="w-full px-6 py-4 bg-white/5 border-2 border-green-500/30 rounded-xl focus:outline-none focus:border-green-500 text-white placeholder-gray-500 font-semibold transition-all"
              />
              <input
                type="email"
                placeholder="Your Email Address"
                className="w-full px-6 py-4 bg-white/5 border-2 border-green-500/30 rounded-xl focus:outline-none focus:border-green-500 text-white placeholder-gray-500 font-semibold transition-all"
              />
              <textarea
                placeholder="Tell me about your project or inquiry..."
                rows="6"
                className="w-full px-6 py-4 bg-white/5 border-2 border-green-500/30 rounded-xl focus:outline-none focus:border-green-500 text-white placeholder-gray-500 font-semibold transition-all resize-none"
              ></textarea>
              <button className="w-full px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-black font-black rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-green-500/50 uppercase tracking-wider">
                Send Message
              </button>
            </div>
          </div>

          {/* Contact Info */}
          <div className="animate-fade-in-delay-2 space-y-8">
            <div>
              <h3 className="text-3xl font-black mb-2 text-green-400">
                Get In Touch
              </h3>
              <p className="text-gray-400 leading-relaxed">
                Reach out anytime. I'm always excited to discuss collaboration
                opportunities, partnerships, and ways we can create positive
                impact together.
              </p>
            </div>

            <div className="space-y-4">
              <div className="group p-6 bg-gradient-to-br from-green-500/10 to-emerald-500/10 border-2 border-green-500/30 rounded-xl hover:border-green-500/100 transition-all hover:scale-105 cursor-pointer">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-green-500/20 rounded-lg group-hover:bg-green-500/40 transition-colors">
                    <Mail size={28} className="text-green-400" />
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm font-semibold mb-1">
                      EMAIL
                    </p>
                    <a
                      href="mailto:letsconnect@andrewpoudel.com"
                      className="text-white font-black hover:text-green-400 transition-colors"
                    >
                      letsconnect@andrewpoudel.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="group p-6 bg-gradient-to-br from-green-500/10 to-emerald-500/10 border-2 border-green-500/30 rounded-xl hover:border-green-500/100 transition-all hover:scale-105 cursor-pointer">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-green-500/20 rounded-lg group-hover:bg-green-500/40 transition-colors">
                    <Phone size={28} className="text-green-400" />
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm font-semibold mb-1">
                      PHONE
                    </p>
                    <a
                      href="tel:9851198535"
                      className="text-white font-black hover:text-green-400 transition-colors"
                    >
                      +977 9851198535
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div>
              <p className="text-gray-400 text-sm font-semibold mb-4">
                FOLLOW ME
              </p>
              <div className="flex gap-4">
                <a
                  href="https://np.linkedin.com/in/andrew-poudel-a28ba7176"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-4 bg-gradient-to-br from-green-500/20 to-emerald-500/20 border-2 border-green-500/30 rounded-xl hover:border-green-500 hover:scale-110 transition-all hover:shadow-lg hover:shadow-green-500/50"
                >
                  <Linkedin size={24} className="text-green-400" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
